module.exports = __webpack_public_path__ + "static/gpx3-d5dc3576a79c7b7ff8389781e611cbe8.png";